import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {DokmeeSettings} from './settingsList/MainSettings'
import {GeneralSettings} from './settingsList/general/GeneralSettings'
import { TriggersSettings } from './settingsList/triggers/TriggersSettings'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dokmee Settings',
    path: '/settings',
    isSeparator: false,
    isActive: false,
  },
]

const SettingsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        
      </Route>
      <Route index element={  <DokmeeSettings />} />
    </Routes>
  )
}

export default SettingsPage
